<div [ngClass]="{'layout-inline-menu': true, 'layout-inline-menu-active':applicationServiceExt.isInlineMenuActive[key]}" [ngStyle]="style" [class]="styleClass">
    <a class="layout-inline-menu-action flex flex-row align-items-center p-3" (click)="onClick($event)" pTooltip="" [tooltipDisabled]="isTooltipDisabled">
        <!--<img src="assets/demo/images/avatar/amyelsner.png" alt="avatar" style="width: 32px; height: 32px;">-->
        <i class="fa fa-user" style="font-size: 2rem;"></i>
        <span class="flex flex-column ml-2">
            <span class="font-bold">{{(currentUser$ | async)?.fullName}}</span>
            <small>{{(currentUser$ | async)?.roleDescription}}</small>
        </span>
        <i class="layout-inline-menu-icon pi pi-angle-down ml-auto"></i>
    </a>

    <ul class="layout-inline-menu-action-panel" [@menu]="applicationServiceExt.isInlineMenuActive[key] ? 'visibleAnimated' : 'hiddenAnimated'">
        <!--<li class="layout-inline-menu-action-item" pTooltip="Settings" [tooltipDisabled]="isTooltipDisabled">
            <a class="flex flex-row align-items-center" [attr.tabindex]="tabIndex" (click)="editUserAsync()">
                <i class="pi pi-cog pi-fw"></i>
                <span>Einstellungen</span>
            </a>
        </li>-->
        <li class="layout-inline-menu-action-item" pTooltip="Logout" [tooltipDisabled]="isTooltipDisabled">
            <a class="flex flex-row align-items-center" [attr.tabindex]="tabIndex" (click)="logoutAsync()">
                <i class="pi pi-power-off pi-fw"></i>
                <span>Abmelden</span>
            </a>
        </li>
    </ul>
</div>
